import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import http from '../api/http';
import { useFiliale } from '../context/FilialeContext';
import PersonnelWizard from '../components/PersonnelWizard';
import BlueHeader from '../components/BlueHeader';

const FicheEmploye = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { filialeId } = useFiliale();
  const [editData, setEditData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (id) {
      fetchEmploye();
    } else {
      setLoading(false);
    }
  }, [id, filialeId]);

  const fetchEmploye = async () => {
    try {
      const params = {};
      if (filialeId && filialeId !== 'all') {
        params.filiale_id = filialeId;
      }
      const response = await http.get(`/api/personnel/${id}`, { params });
      setEditData(response.data);
    } catch (error) {
      console.error('Erreur lors du chargement de l\'employé:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSuccess = (createdId = null) => {
    // Si c'est une création (pas d'ID au départ), rediriger vers les contrats
    if (!id && createdId) {
      navigate('/contrats/13');
    } else {
      navigate('/personnel');
    }
  };

  const handleCancel = () => {
    navigate('/personnel');
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="text-gray-600">Chargement...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <BlueHeader
        title={id ? 'Modifier l\'employé' : 'Créer un nouvel employé'}
        subtitle={id ? 'Modifiez les informations de l\'employé' : 'Remplissez le formulaire pour créer un nouvel employé'}
        showBack={true}
        onBack={() => navigate('/personnel')}
        showMode={true}
        modeText={id ? 'Modification' : 'Création'}
      />

      <div className="px-6 py-8">
        <div className="bg-white rounded-2xl shadow-sm border border-gray-200">
          <PersonnelWizard
            editData={editData}
            onSuccess={handleSuccess}
            onClose={handleCancel}
            isModal={false}
          />
        </div>
      </div>
    </div>
  );
};

export default FicheEmploye;